// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'purchases-credit-memo.page.title': 'Purchases Credit Memos',
    'purchases-credit-memo.page.search_results': 'Search Results',
    'purchases-credit-memo.page.create.title': 'New Credit Memo',
    'purchases-credit-memo.page.search.title': 'Find Credit Memos',
    'purchases-credit-memo.page.edit.title': 'Edit Credit Memo',
    'purchases-credit-memo.page.all': 'All',

    'purchases-credit-memo.button.cancel': 'Cancel',
    'purchases-credit-memo.button.select': 'Select',
    'purchases-credit-memo.button.find': 'Find Credit Memos',
    'purchases-credit-memo.button.search': 'Apply',
    'purchases-credit-memo.button.create': 'Issue Memo',
    'purchases-credit-memo.button.draft': 'Save as Draft',
    'purchases-credit-memo.button.pro_forma': 'Save as Pro Forma',
    'purchases-credit-memo.button.print': 'Print',
    'purchases-credit-memo.button.email': 'Email',
    'purchases-credit-memo.button.send_email': 'Send Email',
    'purchases-credit-memo.button.new': 'New Credit Memo',
    'purchases-credit-memo.button.cancel_draft': 'Cancel Draft',
    'purchases-credit-memo.button.void': 'Void Credit Memo',
    'purchases-credit-memo.button.rollback': 'Rollback Credit Memo',
    'purchases-credit-memo.button.save': 'Save Changes',
    'purchases-credit-memo.button.delete': 'Permanently Delete',
    'purchases-credit-memo.button.edit': 'Edit',
    'purchases-credit-memo.button.restore': 'Restore',
    'purchases-credit-memo.button.refund': 'Refund',
    'purchases-credit-memo.button.reset': 'Reset',
    'purchases-credit-memo.button.record_payment': 'Record Payment',
    'purchases-credit-memo.button.discount': 'Show discount',

    'purchases-credit-memo.placeholder.search': 'Search credit memos',
    'purchases-credit-memo.placeholder.search_items': 'Search items',

    'purchases-credit-memo.message.no_change': 'This credit memo has not changed since it was created.',

    'purchases-credit-memo.link.create_first_credit_memo': 'Click here to create your first credit memo',
    'purchases-credit-memo.link.credit_memos': ' Return to Credit Memos',
    'purchases-credit-memo.link.retry': 'Click here to retry',

    'purchases-credit-memo.checkbox.all': 'Check All',
    'purchases-credit-memo.checkbox.actions_label': 'with selected',

    'purchases-credit-memo.label.items': 'Credit Memo Items',
    'purchases-credit-memo.label.recent': 'Recent',
    'purchases-credit-memo.label.popular': 'Popular',
    'purchases-credit-memo.label.date': 'Date',
    'purchases-credit-memo.label.item': 'Item',
    'purchases-credit-memo.label.return': 'Return',
    'purchases-credit-memo.label.quantity': 'Quantity',
    'purchases-credit-memo.label.unit_cost': 'Unit Cost',
    'purchases-credit-memo.label.total': 'Total',
    'purchases-credit-memo.label.tax_total': 'Tax Total',
    'purchases-credit-memo.label.grand_total': 'Grand Total',
    'purchases-credit-memo.label.sub_total': 'Subtotal',
    'purchases-credit-memo.label.discount': 'Discount',
    'purchases-credit-memo.label.bill_from': 'Bill From',
    'purchases-credit-memo.label.balance': 'Balance',
    'purchases-credit-memo.label.subject': 'Subject',
    'purchases-credit-memo.label.to': 'To',
    'purchases-credit-memo.label.message': 'Message',
    'purchases-credit-memo.label.no_items': 'No items found',
    'purchases-credit-memo.label.void_reason': 'Reason for voiding credit memo',
    'purchases-credit-memo.label.cancel_reason': 'Reason for canceling credit memo',
    'purchases-credit-memo.label.refund_reason': 'Reason for refunding credit memo',
    'purchases-credit-memo.label.rollback_reason': 'Reason for rolling back credit memo',

    'purchases-credit-memo.label.purchases_credit_memo_number': 'Credit Memo No',
    'purchases-credit-memo.label.issue_credit': 'Give store credit?',

    'purchases-credit-memo.label.credit_memo': 'Credit Memo',

    'purchases-credit-memo.label.title': 'Title',
    'purchases-credit-memo.label.refunded_on': 'Refund On',
    'purchases-credit-memo.label.transaction_date': 'Credit Memo Date',
    'purchases-credit-memo.label.printed_at': 'Printed At',
    'purchases-credit-memo.label.opened_at': 'Opened At',
    'purchases-credit-memo.label.paid_at': 'Paid At',

    'purchases-credit-memo.label.bill_from_entity_name': 'Bill To Entity',
    'purchases-credit-memo.label.bill_from_contact_name': 'Bill To Contact',
    'purchases-credit-memo.label.bill_from_address': 'Bill To Address',
    'purchases-credit-memo.label.currency_name': 'Currency',
    'purchases-credit-memo.label.currency_sub_total_in_cents': 'Subtotal',
    'purchases-credit-memo.label.currency_discount_total_in_cents': 'Discount Total',
    'purchases-credit-memo.label.currency_tax_total_in_cents': 'Tax Total',
    'purchases-credit-memo.label.currency_grand_total_in_cents': 'Grand Total',
    'purchases-credit-memo.label.currency_balance_owing_in_cents': 'Balance Owing',

    'purchases-credit-memo.label.sold_by': 'Purchases Person',
    'purchases-credit-memo.label.public_customer_message': 'Public Customer Message',
    'purchases-credit-memo.label.private_note': 'Private Note',

    'purchases-credit-memo.label.created_at': 'Created on',
    'purchases-credit-memo.label.status': 'Status',

    'purchases-credit-memo.sort.field_label': 'Field',
    'purchases-credit-memo.sort.direction_label': 'Direction',
    'purchases-credit-memo.sort.direction_ascending': 'Ascending',
    'purchases-credit-memo.sort.direction_descending': 'Descending',

    'purchases-credit-memo.modal.title.credit_memo_void': 'Void Credit Memo',
    'purchases-credit-memo.modal.title.credit_memo_cancel': 'Cancel Draft Credit Memo',
    'purchases-credit-memo.modal.title.credit_memo_rollback': 'Rollback Credit Memo',
    'purchases-credit-memo.modal.title.credit_memo_refund': 'Refund Credit Memo',
    'purchases-credit-memo.modal.title.credit_memo_restore': 'Restore Credit Memo',

    'purchases-credit-memo.modal.message.credit_memo_cancel': 'Are you sure that you want to cancel this draft? This action cannot be undone.| Are you sure that you want to cancel these drafts? This action cannot be undone.',
    'purchases-credit-memo.modal.message.credit_memo_void':
        'Are you sure that you want to void this credit memo? This action cannot be undone and a credit note will be issued for payments. | Are you sure that you want to void these credit memos? This action cannot be undone and a credit note will be issued for payments.',
    'purchases-credit-memo.modal.message.credit_memo_rollback': 'Are you sure that you want to rollback this credit memo? This action cannot be undone. | Are you sure that you want to void these credit memos? This action cannot be undone',
    'purchases-credit-memo.modal.message.credit_memo_restore': 'Are you sure that you want to restore this credit memo? | Are you sure that you want to restore these credit memos?',
    'purchases-credit-memo.modal.message.credit_memo_refund': 'Are you sure that you want to refund this credit memo? | Are you sure that you want to refund these credit memos?',

    'purchases-credit-memo.success.message.credit_memo_created': 'Your credit memo has been created',
    'purchases-credit-memo.success.message.credit_memo_updated': 'Your credit memo has been updated',
    'purchases-credit-memo.success.message.credit_memo_cancelled': 'Your draft credit memo has been cancelled',
    'purchases-credit-memo.success.message.credit_memo_voided': 'Your credit memo has been voided',
    'purchases-credit-memo.success.message.credit_memo_rolled_back': 'Your credit memo has been rolled back',
    'purchases-credit-memo.success.message.credit_memo_restored': 'Your credit memo has been restored | All selected credit memos were restored',
    'purchases-credit-memo.success.message.credit_memo_refunded': 'Your credit memo has been refunded | All selected credit memos were refunded',
    'purchases-credit-memo.success.message.credit_memo_deleted': 'Your credit memo has been permanently deleted | All selected credit memos were permanently deleted',

    'purchases-credit-memo.error.message.credit_memo_deleted': 'This credit memo was already permanently deleted | These credit memos were already permanently deleted',
    'purchases-credit-memo.error.message.credit_memo_restored': 'This credit memo was already restored | These credit memos were already restored',
    'purchases-credit-memo.error.message.error_loading_page': 'Sorry, there was an error loading purchases-credit-memo.| Sorry, there was an error loading credit memos.',
    'purchases-credit-memo.error.message.items_missing': 'Items have not yet been received. Please update purchase order by receiving the items before proceeding.',
};
